import { useRouter } from 'expo-router';
import { ROUTES } from '@/shared/constants/routes';
import { IS_WEB } from '@/shared/constants/utility';

export function useChannelRouting() {
  const router = useRouter();

  return {
    navigateToChannel: (channelUrl: string) => {
      if (IS_WEB) {
        router.push({
          pathname: ROUTES.MESSAGES.path,
          params: { channelUrl },
        });
      } else {
        router.navigate(ROUTES.MESSAGE(channelUrl).path);
      }
    },
  };
}
